// @flow

export { default } from './TruncatedText';
